module.exports = __webpack_public_path__ + "img/star-icon-white.3415c103.svg";